/* ─── Link ─── */

.root {
  display: inline;
  font: inherit;
  border: none;
  background: none;
  padding: 0;
  cursor: pointer;
  transition: color var(--motion-duration-short3),
    text-decoration-color var(--motion-duration-short3);
}

/* ─── Color variants ─── */

.primary {
  color: var(--md-primary);
}

.secondary {
  color: var(--md-secondary);
}

.inherit {
  color: inherit;
}

/* ─── Underline variants ─── */

.underlineAlways {
  text-decoration: underline;
  text-underline-offset: 0.15em;
}

.underlineHover {
  text-decoration: none;
}

@media (hover: hover) {
  .underlineHover:hover {
    text-decoration: underline;
    text-underline-offset: 0.15em;
  }
}

.underlineNone {
  text-decoration: none;
}

/* ─── Focus ring ─── */

.root:focus-visible {
  --focus-ring-offset: var(--focus-ring-offset-outset);
  border-radius: var(--shape-xs);
}

/* ─── External link icon ─── */

.externalIcon {
  display: inline-block;
  width: 0.75em;
  height: 0.75em;
  margin-inline-start: 0.2em;
  vertical-align: baseline;
  flex-shrink: 0;
}

/* ─── Reduced motion ─── */

@media (prefers-reduced-motion: reduce) {
  .root {
    transition: none;
  }
}
